import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { getAlertsWithQuerry } from "./AlertsUtils/getAlertsWithQuerry";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { yyyymmddGenerator } from "../Analytics/AnalyticsUtils/yyyymmddGenerator";
import { updateSearchParamValues } from "../../utils/updateSearchParamValues";
import { useAlertsStore } from "./AlertsStore/alertsStore";
import {
  alertsTableFilterControlSx,
  alertsTableFilterFieldClassName,
} from "./AlertsUtils/alertsFilterBar";

const FILTER_BY_OPTIONS = [
  { name: "Unresolved Alerts", value: "UNCLAIMED" },
  { name: "Resolved Alerts", value: "CLAIMED" },
  { name: "All Alerts", value: "ALL" },
];

export const FilterMenu = ({
  userFilters,
  setFetchingFilteredData,
  setAlertData,
  navigate,
  setSelectedRow,
  setSeeMoreURL,
  setMP4URL,
  setUserFilters,
  setSelectedButtonsFilled,
  setThumbnailVideos,
  setDateOutsideRange,
  setPage,
  setVideoClipLoading,
  setAlertsToDisplay,
  setPageLoading,
  setSelectedAlertCameraInfo,
  setIgnoreZonesSelectedAlert,
  setAlertsIndexOrder,
  setRefreshInterval,
  currentName,
  setCurrentName,
  pageLoadedNumber,
  setPageLoadedNumber,
  setRefreshingData,
  cameraOptions,
  siteOptions,
  setRefreshingToken,
  refreshingToken,
  setAlertLabels,
  setPeriodHours,
  setQueryLimitHit,
  searchParams,
  setSearchParams,
  detectionType,
  refreshInterval,
  setOutcomeFilterType,
  setForwardArrowDisabled,
  setBackArrowDisabled,
  setShowRefreshButton,
  setRowsSortable,
  setAlertsRefreshing,
  getCurrentSelectedRowKey,
  setVideoProcessing,
}: {
  userFilters: any;
  setFetchingFilteredData: Dispatcher<any>;
  setAlertData: Dispatcher<any>;
  navigate: NavigateFunction;
  setSelectedRow: Dispatcher<any[]>;
  setSeeMoreURL: Dispatcher<string>;
  setMP4URL: Dispatcher<string>;
  setUserFilters: Dispatcher<any>;
  setSelectedButtonsFilled: any;
  setThumbnailVideos: any;
  setDateOutsideRange: Dispatcher<boolean>;
  setPage: Dispatcher<number>;
  setVideoClipLoading: Dispatcher<boolean>;
  setAlertsToDisplay: Dispatcher<boolean>;
  setPageLoading: Dispatcher<boolean>;
  setSelectedAlertCameraInfo: any;
  setIgnoreZonesSelectedAlert: any;
  setAlertsIndexOrder: any;
  setRefreshInterval: any;
  currentName: string;
  setCurrentName: Dispatcher<string>;
  pageLoadedNumber: number;
  setPageLoadedNumber: Dispatcher<number>;
  setRefreshingData: any;
  cameraOptions: any;
  siteOptions: any;
  setRefreshingToken: any;
  refreshingToken: any;
  setAlertLabels: Dispatcher<string[]>;
  setPeriodHours: Dispatcher<number>;
  setQueryLimitHit: Dispatcher<boolean>;
  searchParams: any;
  setSearchParams: any;
  detectionType: string;
  refreshInterval: any;
  setOutcomeFilterType: Dispatcher<string>;
  setForwardArrowDisabled: Dispatcher<boolean>;
  setBackArrowDisabled: Dispatcher<boolean>;
  setShowRefreshButton: Dispatcher<boolean>;
  setRowsSortable: Dispatcher<boolean>;
  setAlertsRefreshing: Dispatcher<boolean>;
  getCurrentSelectedRowKey: () => string | null;
  setVideoProcessing: Dispatcher<boolean>;
}) => {
  const { mutedAlertSites, mutedAlertCameras } = useAlertsStore();
  const selectedOption =
    FILTER_BY_OPTIONS.find((option) => option.name === currentName) ??
    FILTER_BY_OPTIONS[0];

  const applyFilter = (object: { name: string; value: string }) => {
    let newNumber = Number(pageLoadedNumber);
    newNumber += 1;
    setPageLoadedNumber(newNumber);
    localStorage.setItem("pageLoadedNumber", `${newNumber}`);
    localStorage.setItem("latestAlertFilters", JSON.stringify(userFilters));
    setPage(0);
    setOutcomeFilterType("All");
    setFetchingFilteredData(true);
    setCurrentName(object.name);
    getAlertsWithQuerry(
      setAlertData,
      navigate,
      setSelectedRow,
      setFetchingFilteredData,
      setSeeMoreURL,
      setMP4URL,
      userFilters.parent_group,
      userFilters.site,
      userFilters.camera,
      yyyymmddGenerator(userFilters.start_date),
      yyyymmddGenerator(userFilters.end_date),
      userFilters.start_time,
      userFilters.end_time,
      object.value,
      setSelectedButtonsFilled,
      setThumbnailVideos,
      setDateOutsideRange,
      setPage,
      setVideoClipLoading,
      setAlertsToDisplay,
      setPageLoading,
      setSelectedAlertCameraInfo,
      setIgnoreZonesSelectedAlert,
      setAlertsIndexOrder,
      setRefreshInterval,
      setCurrentName,
      setUserFilters,
      setRefreshingData,
      newNumber,
      refreshInterval,
      userFilters,
      cameraOptions,
      siteOptions,
      setRefreshingToken,
      refreshingToken,
      setAlertLabels,
      setPeriodHours,
      setQueryLimitHit,
      setForwardArrowDisabled,
      setBackArrowDisabled,
      setShowRefreshButton,
      setRowsSortable,
      setAlertsRefreshing,
      getCurrentSelectedRowKey,
      mutedAlertSites,
      mutedAlertCameras,
      setVideoProcessing
    );
    setUserFilters((previousState: any) => {
      return {
        ...previousState,
        filter_type: object.value,
      };
    });
    updateSearchParamValues(
      { ...userFilters, filter_type: object.value },
      searchParams,
      setSearchParams,
      detectionType
    );
  };

  return (
    <div className={`${alertsTableFilterFieldClassName} font-mulish`}>
      <Autocomplete
        disablePortal
        disableClearable
        options={FILTER_BY_OPTIONS}
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={selectedOption}
        onChange={(_event, value) => {
          if (value) {
            applyFilter(value);
          }
        }}
        sx={alertsTableFilterControlSx}
        ListboxProps={{ sx: { fontFamily: "Mulish" } }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label="Filter by"
            autoComplete="off"
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.value}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
